import { useState, useEffect } from "react";
import SnackBar from "components/SnackBar/SnackBar";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import classes from "./OffboardingModalContent.module.css";
import { useSelector, useDispatch } from "react-redux";
import { obtInfoManagementActions } from "Store/obtInfoManagement";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";

const OffboardingModalContent = (props) => {
  const details = useSelector((state) => state.obtInfoManagement);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const emailPattern =
    /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  const validateEmails = (emails) => {
    const emailList = emails.split(";");
    for (const email of emailList) {
      const trimmedEmail = email.trim();
      if (trimmedEmail.length > 0 && !emailPattern.test(trimmedEmail)) {
        return false;
      }
    }
    return true;
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setIsValid(validateEmails(value));
    dispatch(obtInfoManagementActions.setClientDistro(event.target.value));
  };

  const handleSave = () => {
    if (isValid) {
      props.handleSave();
    } else {
      setSnack({
        open: true,
        message: "Invalid client distro",
        severity: "error",
      });
    }
  };

  useEffect(() => {
    setLoader(props.loading);
  }, [props.loading]);
  return (
    <>
      {loader ? (
        <div className={classes.loader}>
          <CircularProgress sx={{ color: "#A8A8A8" }} />
        </div>
      ) : null}
      <p className={classes.header}>
        Offboarding Notification
        <CloseIcon
          sx={{
            fontSize: "23px",
            marginLeft: "19rem",
            cursor: "pointer",
          }}
          onClick={props.onClose}
        ></CloseIcon>
      </p>
      <Grid container spacing={2} sx={{ marginTop: "10px" }}>
        <Grid className={classes.label} item xs={6}>
          <p>Contractual Client Distro</p>
        </Grid>
        <Grid item xs={4} className={classes.label} sx={{ marginLeft: "20px" }}>
          <p>Client Offboarding</p>
        </Grid>
        <Grid item xs={6}>
          {" "}
          <TextField
            type="text"
            id="outlined-basic"
            variant="outlined"
            required
            multiline
            placeholder="Input"
            rows={1}
            value={details.clientDistro}
            onChange={handleInputChange}
            className={classes.textfield}
            sx={{
              "& .MuiInputBase-input": {
                color: "#3f5765",
              },
            }}
          />
        </Grid>
        <Grid item xs={6}>
          {" "}
          <Checkbox
            sx={{
              "& .MuiSvgIcon-root": { fontSize: 28, color: "#3299FF" },
              marginLeft: "20px",
              borderRadius: 3,
            }}
            checked={details.clientOffboarding}
            onChange={(e) => {
              dispatch(
                obtInfoManagementActions.toggleClientOffboarding(
                  e.target.checked
                )
              );
            }}
          />
        </Grid>
      </Grid>
      <div className={classes.buttonContainer}>
        <Button
          sx={{
            textTransform: "none",
            borderRadius: "7px",
            borderColor: "#1a8cff",
          }}
          variant="outlined"
          onClick={props.onClose}
        >
          Cancel
        </Button>
        <Button
          sx={{
            textTransform: "none",
            borderRadius: "7px",
            backgroundColor: "#3299FF",
          }}
          variant="contained"
          onClick={handleSave}
          disabled={!props.isEdit}
        >
          Save
        </Button>
      </div>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </>
  );
};

export default OffboardingModalContent;
